import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Program } from "@/components/site/Program";
import { Exhibitors } from "@/components/site/Exhibitors";
import { Order } from "@/components/site/Order";
import { Tickets } from "@/components/site/Tickets";
import { Participate } from "@/components/site/Participate";
import { Visit } from "@/components/site/Visit";
import { Sponsors } from "@/components/site/Sponsors";
import { Contact, Footer } from "@/components/site/Contact";
import { Countdown } from "@/components/site/Countdown";
import Admin from "@/pages/Admin";

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-cream text-ink" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Program />
        <Exhibitors />
        <Order />
        <Tickets />
        <Participate />
        <Visit />
        <Sponsors />
        <Contact />
      </main>
      <Footer />
      <Countdown />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1614",
            color: "#FDFBF7",
            border: "1px solid rgba(212,175,55,0.4)",
            borderRadius: "2px",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
